// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-notification-docs',
    templateUrl: './notification.docs.generated.html',
})
export class UINotificationDocs { }
